import { LocaleCode, MarketCode } from '@tink/config/src/markets';

export { VERSIONS } from '@tink/config/src/tinkLinkConfig';

export { MARKETS } from '@tink/config/src/markets';

export { LOCALES } from '@tink/config/src/markets';

export const DEFAULT_MARKET = MarketCode.SE;

export const DEFAULT_LOCALE = LocaleCode.EN;

export const BANK_ID_IMAGE = 'https://cdn.tink.se/link/assets/bankid-logo-2023.svg';

export const DE_SEARCH_GRAPHIC = 'https://cdn.tink.se/link/assets/de-search-graphic.png';

export const LEGAL_TEXT_MARKETS = [MarketCode.AT];

export const TINK_LOGO = 'https://cdn.tink.se/tink-logos/HIGH/Tink_Wordmark_Black.png';

export const BANK_LOGO_PLACEHOLDER = 'https://cdn.tink.se/provider-images/placeholder.png';
